import {
	ConfigService,
	ConfigServiceChildI,
	ConfigServiceGroupI,
} from "../../App.types";

export type ConfigServiceOptionI = Omit<ConfigServiceChildI, "childId"> & {
	id: string;
};

// A group is either a single service, a service with accessories to pick from
// (serviceTypeId + children), or several services to pick from (children only).
export const toOptions = (
	group: ConfigServiceGroupI,
): ConfigServiceOptionI[] =>
	group.children.length > 0
		? group.children.map((child) => ({ ...child, id: child.childId }))
		: [{ ...group, id: group.serviceTypeId }];

export const hasAccessories = (group: ConfigServiceGroupI) =>
	!!group.serviceTypeId && group.children.length > 0;

// Same mapping as the product page's config service selection
export const getCartParams = (
	group: ConfigServiceGroupI,
	option: ConfigServiceOptionI,
) => ({
	serviceId: hasAccessories(group) ? group.serviceTypeId : option.id,
	optionIds: hasAccessories(group) ? [option.id] : [],
});

// The API only returns the first service in each group, so an accessory picked
// on the product page may not be among the options; matching the service is enough
export const isAttached = (
	group: ConfigServiceGroupI,
	attachedServices: ConfigService[],
) => {
	const serviceIds = hasAccessories(group)
		? [group.serviceTypeId]
		: toOptions(group).map((option) => option.id);

	return attachedServices.some((attached) =>
		serviceIds.includes(String(attached.id)),
	);
};
